var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-popup"},[_c('div',{staticClass:"tabs-popup__inner"},[_c('div',{staticClass:"tabs-popup__items"},[_vm._t("item-tab")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }